import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, ArrowDownIcon } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'Checklist Maestro de Autocuidado Diario',
  subtitle: 'Tu lista de verificación lista para imprimir y usar cada día',
  value: '$27.00',
  image: 'https://cdn.magicpatterns.com/uploads/fjFKUfzoRwV57AFvqZiKn2/FHOTO_BONO_1_RUTINA_1777565446319.png',
  copy: ['Olvídate de intentar recordar qué revisar cada mañana.', 'Este checklist maestro te da una lista clara, ordenada y lista para imprimir — o guardar en tu teléfono — con todo lo que necesitas verificar cada día.', 'Sin adivinar. Sin olvidar. Sin complicaciones.', 'Solo marcas, avanzas y te sientes bien con tu rutina.']
}, {
  number: 2,
  title: 'Guía Rápida de Calzado Cómodo',
  subtitle: 'Cómo elegir mejor lo que usas cada día sin gastar de más',
  value: '$19.00',
  image: 'https://cdn.magicpatterns.com/uploads/6LLV5VstfVNJx7JDuGQ2SB/BONO_2_FHOTA_RUTINA_.png',
  copy: ['Lo que pones en tus pies cada mañana influye en cómo te sientes todo el día.', 'Esta guía rápida te explica en palabras simples qué buscar — y qué evitar — cuando eliges tu calzado diario.', 'Sin marcas. Sin precios exagerados. Solo criterios claros para tomar mejores decisiones desde hoy.', 'Porque un buen zapato no siempre es el más caro. A veces es simplemente el más amable.']
}, {
  number: 3,
  title: 'Plan de 7 Días para Crear tu Rutina',
  subtitle: 'Un plan diario simple para convertir la guía en un hábito real',
  value: '$17.00',
  image: 'https://cdn.magicpatterns.com/uploads/onHnJsFK2uXSnpsWzrXrkd/BONO_3_FHOTO_RUTINA_.png',
  copy: ['Saber qué hacer no siempre es suficiente.', 'Este plan de 7 días te guía paso a paso durante tu primera semana — con una acción pequeña y clara para cada día — para que la rutina no se quede guardada en tu teléfono sino que se convierta en parte de tu vida.', 'Día 1. Día 2. Día 3. Todo claro. Todo simple. Todo en español.', 'Porque los hábitos no se construyen en un día — pero sí empiezan en uno.']
}];
export function Bonuses() {
  const scrollToComprar = () => {
    const el = document.querySelector('#comprar');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="bonos" className="py-24 bg-cream-dark/30" data-id="element-35">
      <div className="max-w-5xl mx-auto px-6" data-id="element-36">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-8" data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight" data-id="element-38">
            "Y eso no es todo lo que recibes hoy."
          </h2>
          <div className="w-16 h-[1px] bg-bronze mx-auto mb-8" data-id="element-39" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="max-w-3xl mx-auto text-center mb-16" data-id="element-40">
          <p className="text-lg text-charcoal-light leading-relaxed mb-4" data-id="element-41">
            Cuando decides empezar tu rutina de autocuidado hoy, no solo recibes
            la guía principal.
          </p>
          <p className="text-lg text-charcoal-light leading-relaxed mb-4" data-id="element-42">
            Decidimos agregar{' '}
            <strong className="text-charcoal" data-id="element-43">3 bonos especiales</strong> — sin
            costo adicional — porque queremos que tengas todo lo que necesitas
            para empezar con confianza, claridad y sin excusas.
          </p>
          <p className="text-lg text-charcoal-light leading-relaxed mb-2" data-id="element-44">
            Estos bonos tienen un valor real{' '}
            <strong className="text-charcoal" data-id="element-45">de más de $60.00</strong>.
          </p>
          <p className="text-xl font-serif text-bronze-dark font-semibold" data-id="element-46">
            Hoy los recibes completamente gratis.
          </p>
        </motion.div>

        {/* Bonus Cards */}
        <div className="space-y-20" data-id="element-47">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-10 items-center`} data-id="element-48">
              {/* Image */}
              <div className="w-full md:w-1/2" data-id="element-49">
                <div className="relative overflow-hidden rounded-sm shadow-xl shadow-bronze/10 border border-bronze/15" data-id="element-50">
                  <img src={bonus.image} alt={bonus.title} className="w-full object-cover" data-id="element-51" />
                </div>
              </div>

              {/* Content */}
              <div className="w-full md:w-1/2" data-id="element-52">
                <div className="flex items-center gap-3 mb-4" data-id="element-53">
                  <div className="w-10 h-10 rounded-full bg-bronze/15 flex items-center justify-center" data-id="element-54">
                    <GiftIcon className="w-5 h-5 text-bronze-dark" data-id="element-55" />
                  </div>
                  <span className="text-sm font-semibold tracking-widest uppercase text-bronze-dark" data-id="element-56">
                    Bono #{bonus.number}
                  </span>
                </div>

                <h3 className="text-2xl md:text-3xl font-serif mb-2 leading-snug" data-id="element-57">
                  {bonus.title}
                </h3>
                <p className="text-bronze-dark font-medium mb-6 italic" data-id="element-58">
                  {bonus.subtitle}
                </p>

                <div className="space-y-3 text-charcoal-light leading-relaxed mb-6" data-id="element-59">
                  {bonus.copy.map((paragraph, pIndex) => <p key={pIndex} data-id="element-60">{paragraph}</p>)}
                </div>

                <div className="flex items-center gap-3 flex-wrap" data-id="element-61">
                  <span className="text-charcoal-light line-through" data-id="element-62">
                    Valorado en {bonus.value}
                  </span>
                  <span className="text-bronze-dark font-bold text-lg" data-id="element-63">
                    → Tuyo gratis hoy
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Value Summary Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7
      }} className="mt-16 max-w-2xl mx-auto" data-id="element-64">
          <div className="bg-sage text-white text-center py-8 px-6 rounded-sm shadow-lg shadow-sage/20 relative overflow-hidden" data-id="element-65">
            <div className="absolute top-0 left-0 w-full h-1 bg-bronze-light" data-id="element-66" />
            <p className="font-serif text-xl md:text-2xl leading-snug mb-2" data-id="element-67">
              Todo junto vale{' '}
              <span className="line-through opacity-70" data-id="element-68">$77.00</span>
            </p>
            <p className="font-serif text-2xl md:text-3xl font-bold" data-id="element-69">
              Hoy lo llevas todo por solo{' '}
              <span className="text-bronze-light" data-id="element-70">$14.00</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}